export const REACTION_TYPE = {
  THANK_YOU: "THANK_YOU",
  USEFUL: "USEFUL",
  SURPRISING: "SURPRISING",
  INTERESTING: "INTERESTING",
  NOT_A_FAN: "NOT_A_FAN",
} as const;

export type ReactionType = (typeof REACTION_TYPE)[keyof typeof REACTION_TYPE];
